import { APPLICATION_GROUP_BY, Route } from '@/core/entities/types/routes';
import { createRouteLoaderPageDetails } from '@/core/utils/routes.utils';
import { List as DigitalHospitalList } from '@/modules/companyDigitalHospitalConfig/pages/list/list';
import { List as HealthDataList } from '@/modules/companyHealthDataConfig/pages/list/list';
import { SelectHealthConfig } from '@/modules/healthManage/pages/selectHealthConfig';
import { USER_TYPE } from '@/services/users/endpoints/users';
import ICONS from '@/shared/entities/constants/icons';

export enum ROUTE_HEALTH_MANAGE {
  SELECT = 'health-manage-select',
  HEALTH_DATA = 'health-manage-health-data',
  DIGITAL_HOSPITAL = 'health-manage-digital-hospital',
}

export const routeById: Record<ROUTE_HEALTH_MANAGE, Route> = {
  [ROUTE_HEALTH_MANAGE.SELECT]: {
    path: '',
    Component: SelectHealthConfig,
    id: ROUTE_HEALTH_MANAGE.SELECT,
    meta: {
      groupedBy: APPLICATION_GROUP_BY.BROKER,
      permission: {
        type: USER_TYPE.BROKER,
      },
    },
    loader() {
      return createRouteLoaderPageDetails({
        groupedBy: APPLICATION_GROUP_BY.BROKER,
        icon: ICONS.TRENDING_UP,
        name: 'Gestão de saúde',
        description:
          'Defina quais empresas poderão visualizar os banners de acesso aos indicadores na página inicial',
        title: 'Gestão de saúde',
      });
    },
  },
  [ROUTE_HEALTH_MANAGE.HEALTH_DATA]: {
    Component: HealthDataList,
    id: ROUTE_HEALTH_MANAGE.HEALTH_DATA,
    path: 'health-data',
    meta: {
      groupedBy: APPLICATION_GROUP_BY.BROKER,
      permission: {
        type: USER_TYPE.BROKER,
      },
    },
    loader() {
      return createRouteLoaderPageDetails({
        groupedBy: APPLICATION_GROUP_BY.BROKER,
        icon: ICONS.TRENDING_UP,
        name: 'Indicadores Plano de Saúde',
        description:
          'Gerencie quais empresas podem visualizar o banner de acesso aos indicadores do Plano de Saúde na página inicial.',
        title: 'Indicadores Plano de Saúde',
      });
    },
  },
  [ROUTE_HEALTH_MANAGE.DIGITAL_HOSPITAL]: {
    Component: DigitalHospitalList,
    id: ROUTE_HEALTH_MANAGE.DIGITAL_HOSPITAL,
    path: 'digital-hospital',
    meta: {
      groupedBy: APPLICATION_GROUP_BY.BROKER,
      permission: {
        type: USER_TYPE.BROKER,
      },
    },
    loader() {
      return createRouteLoaderPageDetails({
        groupedBy: APPLICATION_GROUP_BY.BROKER,
        icon: ICONS.TRENDING_UP,
        name: 'Indicadores de hospital digital',
        description:
          'Gerencie quais empresas podem visualizar o banner de acesso aos indicadores do Hospital Digital na página inicial.',
        title: 'Indicadores de hospital digital',
      });
    },
  },
};
